import { RefObject, useRef } from 'react';

import { useGesture } from '@use-gesture/react';

import { isApple } from '../helpers/platformFunctions';

import { XYPosition } from './use-dynamic-viewport';

export interface WheelScrollProps {
	ignoreMouseWheel: boolean;
	handleZoom: (delta: number, viewportPosition?: XYPosition) => void;
	handleVerticalScroll: (delta: number) => void;
	target: RefObject<Element>;
	enabled: boolean;
}
const useWheelPanAndZoom = ({
	ignoreMouseWheel,
	handleZoom,
	handleVerticalScroll,
	target,
	enabled,
}: WheelScrollProps): void => {
	const positionRef = useRef<XYPosition>();
	useGesture(
		{
			onMouseMove: (state) => {
				// Calculate mouse move from page X/Y, as offsets would trigger for children giving bad values;
				const targetRect = target?.current?.getBoundingClientRect();
				if (!targetRect) return;

				positionRef.current = { x: state.event.pageX - targetRect.x, y: state.event.pageY - targetRect.y };
			},
			onMouseLeave: () => (positionRef.current = undefined),
		},
		{
			target,
		},
	);
	useGesture(
		{
			onWheel: ({ delta: [, yDelta], event, metaKey, ctrlKey }) => {
				event.stopPropagation();
				if (!enabled) return;
				if (yDelta === 0) return;
				if (ignoreMouseWheel) return;
				(isApple ? metaKey : ctrlKey) ? handleZoom(yDelta, positionRef.current) : handleVerticalScroll(yDelta);
				event.preventDefault();
			},
		},
		{
			target,
			enabled: !ignoreMouseWheel,
			eventOptions: { passive: false },
		},
	);
};

export default useWheelPanAndZoom;
